var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-list"},[_c('selector',{attrs:{"select":"selector-order"},on:{"handleTicketOrder":_vm.handleTicketOrder}}),(_vm.orderTypeList.length > 0)?_c('router-view'):_c('emptyContent',{attrs:{"text":"You have no order history."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }